export default {
  title: 'A PÁGINA QUE PROCURA DEVE ESTAR ALGURES AQUI...',
  description: 'Está à procura de uma das páginas abaixo?',
  not_found: 'Não conseguimos encontrar o URL que introduziu. Verifique se foi introduzido corretamente.',
  no_restaurants: {
    title: 'Esta loja ainda não aceita encomendas online',
    description: 'Volte em breve.',
  },
  toasts: {
    failed_to_load_stores: 'Falha ao carregar as lojas, por favor atualize a página',
  },
};
